import { MobileReferenceValue } from 'src/redux/mobileReferenceReducer'
import { MotorbikeDetail } from 'src/redux/motorbikesReducer'

interface SpecItem {
  label: string
  value: string
}

type Translate = (key: string) => string

interface EquipmentSpecsArgs {
  motorbike: MotorbikeDetail | null
  driveTypes: MobileReferenceValue[]
  gearBoxes: MobileReferenceValue[]
  t: Translate
}

const formatYesNo = (value: boolean | null | undefined, yes: string, no: string): string => {
  if (value === true) {
    return yes
  }
  if (value === false) {
    return no
  }
  return '-'
}

const formatMonth = (value: string | null | undefined): string => {
  if (value === null || typeof value === 'undefined' || value.length < 7) {
    return '-'
  }
  return value.slice(0, 7)
}

const formatReference = (code: string | null | undefined, values: MobileReferenceValue[]): string => {
  if (code === null || typeof code === 'undefined' || code.length === 0) {
    return '-'
  }
  const label = values.find((item) => item.code === code)?.label?.trim() ?? ''
  return label.length > 0 ? label : code
}

export const motorbikeEquipmentSpecs = ({ motorbike, driveTypes, gearBoxes, t }: EquipmentSpecsArgs): SpecItem[] => {
  const yes = t('my_vehicles.promotion_yes')
  const no = t('my_vehicles.promotion_no')
  return [
    { label: t('my_vehicles.promotion_metallic'), value: formatYesNo(motorbike?.metallic, yes, no) },
    { label: t('my_vehicles.promotion_drive_type'), value: formatReference(motorbike?.drive_type, driveTypes) },
    { label: t('my_vehicles.promotion_gear_box'), value: formatReference(motorbike?.gear_box, gearBoxes) },
    { label: t('my_vehicles.promotion_damage'), value: formatYesNo(motorbike?.damage_unrepaired, yes, no) },
    { label: t('my_vehicles.promotion_abs'), value: formatYesNo(motorbike?.abs, yes, no) },
    { label: t('my_vehicles.promotion_heated_grips'), value: formatYesNo(motorbike?.heated_grips, yes, no) },
    { label: t('my_vehicles.promotion_box'), value: formatYesNo(motorbike?.box, yes, no) },
    { label: t('my_vehicles.promotion_windshield'), value: formatYesNo(motorbike?.windshield, yes, no) },
    { label: t('single_offer.motorbike_next_hu'), value: formatMonth(motorbike?.next_hu) },
    { label: t('my_vehicles.promotion_service_history'), value: formatYesNo(motorbike?.full_service_history, yes, no) }
  ]
}
